module.exports = __webpack_public_path__ + "static/nabil-92cbed0d6404a712880d0caf2de806b7.jpg";